/**
 * Note - 'Entity' = Customer or Supplier.
 *
 */
import { IAbstractContact, ICustomer, ISupplier, Maybe } from '../graphql/schema/p4types';
import { CSSProperties, ReactElement } from 'react';
import { PREFERRED_CONTACT_STYLE } from '../components/report/ContactEmailEditor';

/**
 * Representation of an email for Document Modal/Carousel purposes.
 * id is typically a number (from the relevant entity) but may be a string for additional records, (like 'recipient' for the customer header email).
 * style is an optional provision to override the style in Option Renderers when displaying the email (For example, to highlight a preferred address).
 */
export type IEntityEmail = {
  id: number | string;
  email: string;
  name: string;
  style?: CSSProperties;
  suffix?: ReactElement;
};

export const emailFromEntity = (
  entity: ICustomer | ISupplier,
  entityContact?: Maybe<IAbstractContact>,
  recipients: Array<IAbstractContact> = [],
  { allowEntityEmail = true, showFlagOnDefault = false } = {}
) => {
  const emailStyle = showFlagOnDefault ? PREFERRED_CONTACT_STYLE : undefined;

  const emailList: Array<IEntityEmail> = entityContact?.email
    ? [
        {
          id: entityContact.id!,
          email: entityContact.email,
          name: entityContact.name?.fullName,
          style: emailStyle,
        },
      ]
    : [];
  recipients
    .filter(
      //De-duplication & filtering out of entries with no email address.
      (contact, idx, self) =>
        !!contact.email &&
        !emailList.find((email) => email.id === contact.id || email.email === contact.email) &&
        self.findIndex((con) => con.email === contact.email) === idx
    )
    .forEach((contact) =>
      emailList.push({
        id: contact.id!,
        email: contact.email!,
        name: contact.name?.fullName,
        style: emailStyle,
      })
    );
  if (allowEntityEmail && emailList.length === 0 && entity?.email) {
    return [
      {
        id: 'customer',
        email: entity.email,
        name: entity.name,
        style: emailStyle,
      },
    ];
  }
  return emailList;
};
